module.exports = __webpack_public_path__ + "static/media/MMProLogoSmall.e22c4667.svg";